import React, {useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {Formats} from "../../../../../constants/Formats";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import dayjs from "dayjs";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import RequestVisitorDetailDialog from "../../../components/RequestVisitorDetailDialog";
import {RequestVisitorApi} from "../../../../../modules/vms/api/RequestVisitorApi";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import VisitRequestDetailDialog from "../../../components/VisitRequestDetailDialog";
import {Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel} from "@mui/material";
import DictItemUtils from "../../../../../modules/dict/utils/DictItemUtils";
import {DictItemDto} from "../../../../../modules/dict/dto/DictItemDto";
import {VisitorAccessLogDto} from "../../../../../modules/vms/dto/VisitorAccessLogDto";
import {SortDirection} from "@mui/material/TableCell/TableCell";
import {VisitorStatus} from "../../../../../modules/vms/enums/VisitorStatus";
import StringUtils from "../../../../../utils/StringUtils";
import {VisitRequestClassify} from "../../../../../modules/vms/enums/VisitRequestClassify";
import {useConfirm} from "material-ui-confirm";

export type SearchResultProps = {
    searchResult: Array<RequestVisitorDto>;
    visitorTypes: Array<DictItemDto>;
    // onSortSearch: (sortField: string, sortType: string) => void;

    onSearch: () => void;
};

const SearchResult: React.FC<SearchResultProps> = (props) => {
    const intl = useIntl();
    const confirm = useConfirm();

    const [openRequestDetailModal, setOpenRequestDetailModal] = useState(false);
    const [openVisitorDetailModal, setOpenVisitorDetailModal] = useState(false);

    const [requestVisitor, setRequestVisitor] = useState(new RequestVisitorDto());

    const [visitRequest, setVisitRequest] = useState(new VisitRequestDto());
    const [tableSortField, setTableSortField] = useState("");
    const [tableSortType, setTableSortType] = useState<SortDirection>('asc');

    const handleVisitorDetail = async (record: RequestVisitorDto) => {
        const responseResult = await RequestVisitorApi.getVisitorDetailById(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setRequestVisitor(responseResult.data);
            setOpenVisitorDetailModal(true);
        }
    };
    // const handleSort = (sortField: string) => {
    //     let sortType: SortDirection = 'asc';
    //     if (tableSortField === sortField) {
    //         if (tableSortType === 'asc') {
    //             sortType = 'desc';
    //         }
    //     }
    //     setTableSortField(sortField);
    //     setTableSortType(sortType);
    //     props.onSortSearch(sortField, sortType);
    // };


    const handleCheckOut = async (record: RequestVisitorDto) => {
        const responseResult = await RequestVisitorApi.checkout(record.id, record.accessCardNumber);
        if (responseResult.status === HttpStatus.SUCCESS) {
            props.onSearch()
        }
    };

    const handleCheckOutConfirm = async (record: RequestVisitorDto) => {
        confirm({title: intl.formatMessage({id: 'VMS_VISITOR_MSG_CHECKOUT_CONFIRM'})})
            .then(async () => {
                handleCheckOut(record);
            })
            .catch(() => {
                console.log('cancel');
            });

    };

    return (
        <div>

            <RequestVisitorDetailDialog open={openVisitorDetailModal}
                                        onClose={() => setOpenVisitorDetailModal(false)}
                                        requestVisitor={requestVisitor}/>
            <TableContainer>
                <Table size="small"
                       sx={{minWidth: 1000, overflow: 'auto'}}>
                    <TableHead>
                        <TableRow>
                            {/*<TableCell>{intl.formatMessage({id: 'VMS_VISIT_REQUEST_NUMBER'})}</TableCell>*/}
                            <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ARRIVE_DATE'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_NAME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_VISIT_CODE"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_STATUS"})}</TableCell>
                            {/*<TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_CHECKIN_TIME"})}</TableCell>*/}
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_IN_TIME"})}</TableCell>
                            {/*<TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_CHECKOUT_TIME"})}</TableCell>*/}
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_ACCESS_OUT_TIME"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.searchResult.map((row, index) => {
                            const checkOutLog = row.checkOutLog && Object.assign(new VisitorAccessLogDto(), row.checkOutLog);
                            const checkInLog = row.checkInLog && Object.assign(new VisitorAccessLogDto(), row.checkInLog);
                            const visitRequest = row.visitRequest ? row.visitRequest : new VisitRequestDto();
                            let rowStyle = {};
                            if (checkInLog && checkOutLog == null) {
                                if (dayjs(row.visitRequest?.arriveEndDate, Formats.DATE_SIMPLE).isBefore(dayjs(), 'day')) {
                                    rowStyle = {backgroundColor: "#ffb08e"};
                                }
                            }
                            return (
                                <TableRow key={row.id} style={rowStyle}>
                                    {/*<TableCell>{row.visitRequest?.number}</TableCell>*/}
                                    <TableCell>{StringUtils.formatDate(visitRequest.arriveStartDate) }</TableCell>
                                    {/*<TableCell><FormattedMessage*/}
                                    {/*    id={VisitRequestClassify.Map.get(visitRequest.classify)}/></TableCell>*/}
                                    <TableCell>{row.fullName}</TableCell>
                                    <TableCell>{row.company}</TableCell>
                                    <TableCell>{row.visitCode}</TableCell>
                                    <TableCell>{row.plateNumber}</TableCell>
                                    <TableCell><FormattedMessage id={VisitorStatus.Map.get(row.status)}/></TableCell>
                                    {/*<TableCell>{checkInLog?.fetchAccessDateTime()}</TableCell>*/}
                                    <TableCell>{StringUtils.formatDate(row.accessInLog?.accessDate) + " " + StringUtils.formatTime(row.accessInLog?.accessTime)}</TableCell>
                                    {/*<TableCell>{checkOutLog?.fetchAccessDateTime()}</TableCell>*/}
                                    <TableCell>{StringUtils.formatDate(row.accessOutLog?.accessDate) + " " + StringUtils.formatTime(row.accessOutLog?.accessTime)}</TableCell>
                                    <TableCell>
                                        <Link href={'javascript:void(0)'} onClick={() => handleVisitorDetail(row)}>
                                            <FormattedMessage id={'COMMON_DETAIL'}/>
                                        </Link>
                                    </TableCell>

                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default SearchResult;